<i18n>
{
	"en": {
		"generalStatus": "General status",
		"stretch": "Stretch",
		"actual": "Actual",
		"ata": "ATA",
		"atd": "ATD",
		"eta": "ETA",
		"etd": "ETD",
		"ediLog": "EDI log",
		"save": "Save",
		"consignor": "Consignor",
		"despatchParty": "Despatch party",
		"consignee": "Consignee",
		"deliveryParty": "Delivery party",
		"setTime": "Set time",
		"unableToFindOrder": "Could not find order to save",
		"unableToUpdateOrder": "Could not update order",
		"failedToSave": "Failed to save order",
		"validationErrors": "Failed to save order due to validation errors",
		"invalidEtd": "Invalid ETD",
		"invalidEta": "Invalid ETA",
		"invalidAtd": "Invalid ATD",
		"invalidAta": "Invalid ATA",
		"transportInformation": "Transport Information",
		"stretches": "Stretches",
		"details": "Details",
		"freightLines": "Freight lines",
		"priceLines": "Price lines",
		"loadingInformation": "Loading information",
		"freeText": "Free text",
		"events": "Events",
		"viaAddress": "Via address",
		"removeStretch": "Remove stretch",
		"noStartFound": "No suborder mathced the orders from location",
		"routeLost": "Could not make a valid route from suborders",
		"arrival": "Arrival",
		"departure": "Departure",
		"setArrivalTime": "Set arrival time",
		"setDepartureTime": "Set departure time",
		"orderSaved": "The order was saved",
		"cancelLabel": "Cancel",
		"totalPrice": "Total price",
		"notSet": "Not set",
		"poReference": "PO reference",
		"sendersReference": "Senders reference",
		"otherReferences": "Other references",
		"systemReferences": "System references",
		"invoiceCurrency": "Invoice currency:",
		"invoiceNumber": "Invoice number:",
		"baseCurrency": "Base currency:",
		"operationalStatus": "Operational status",
		"shouldNotBePlanned": "Should not be planned",
		"billingType": "Billing status:",
		"billingTypeAborted": "Cancelled",
		"billingTypeNotCleared": "Not cleared",
		"billingTypeSettlement": "Ready for settlement",
		"billingTypeInvoice": "Ready for invoice",
		"billingTypeUnkown": "Unknown"
	},
	"no": {
		"generalStatus": "Generell status",
		"stretch": "Strekning",
		"actual": "Faktisk",
		"ata": "ATA",
		"atd": "ATD",
		"eta": "ETA",
		"etd": "ETD",
		"ediLog": "EDI logg",
		"save": "Lagre",
		"consignor": "Avsender",
		"despatchParty": "Henteadresse",
		"consignee": "Mottaker",
		"deliveryParty": "Leveringsadresse",
		"setTime": "Sett tid",
		"unableToFindOrder": "Kunne ikke finne oppdrag å lagre",
		"unableToUpdateOrder": "Kunne ikke oppdatere oppdrag",
		"failedToSave": "Kunne ikke lagre oppdrag",
		"validationErrors": "Kunne ikke lagre oppdrag på grunn av valideringsfeil",
		"invalidEtd": "Ugyldig ETD",
		"invalidEta": "Ugyldig ETA",
		"invalidAtd": "Ugyldig ATD",
		"invalidAta": "Ugyldig ATA",
		"openTmsR10": "Åpne ordre i TMS R10",
		"openTmsR10Success": "En spørring har blitt sendt til TMS R10",
		"openTmsR10Error": "Spørringen mot TMS R10 feilet med melding: ",
		"transportInformation": "Transportinformasjon",
		"stretches": "Strekninger",
		"details": "Detaljer",
		"freightLines": "Fraktlinjer",
		"priceLines": "Prislinjer",
		"loadingInformation": "Lasteinformasjon",
		"freeText": "Fritekst",
		"events": "Hendelser",
		"viaAddress": "Via adresse",
		"removeStretch": "Fjern strekning",
		"noStartFound": "Ingen underoppdrag matchet oppdragets fra adresse",
		"routeLost": "Kunne ikke lage en gyldig rute fra dette oppdragets underoppdrag",
		"arrival": "Ankomst",
		"departure": "Avgang",
		"setArrivalTime": "Sett ankomsttid",
		"setDepartureTime": "Sett avgangstid",
		"orderSaved": "Oppdraget ble lagret",
		"cancelLabel": "Avbryt",
		"totalPrice": "Total pris",
		"notSet": "Ikke satt",
		"poReference": "PO referanse",
		"sendersReference": "Senders referanse",
		"otherReferences": "Andre referanser",
		"systemReferences": "Systemreferanser",
		"invoiceCurrency": "Faktura-valuta:",
		"invoiceNumber": "Fakturanummer:",
		"baseCurrency": "Grunn-valuta:",
		"operationalStatus": "Operativ status",
		"shouldNotBePlanned": "Skal ikke planlegges",
		"billingType": "Faktura status:",
		"billingTypeAborted": "Annullert",
		"billingTypeNotCleared": "Ikke klarert",
		"billingTypeSettlement": "Klar for avregning",
		"billingTypeInvoice": "Klar for fakturering",
		"billingTypeUnkown": "Ukjent"
	}
}
</i18n>
<template>
	<div ref="newOrder" class="new-order">

		<div class="general-status">

			<OrderTypesFormInput
				:selectedItem="order.orderType"
				:orderHasTrip="orderHasTrip"
				:disabled="orderIsLocked"
				enableFocusNextOnKeyboardSelect

				@change="setValue({key: 'orderType', value: $event})"
			/>

			<OrderStatusesFormInput
				v-if="orderHasTrip"
				:selectedItem="order.status"
				:disabled="orderIsLocked"
				enableFocusNextOnKeyboardSelect

				@change="setValue({ key: 'status', value: $event })"
			/>
			<t-labeled-value
				v-else
				:label="$t('operationalStatus')"
				:value="$t('shouldNotBePlanned')"
				labelMarginBottom="11px"
			/>

			<GoodsTypesFormInput
				:selectedItem="order.goodsType"
				:disabled="orderIsLocked"
				enableFocusNextOnKeyboardSelect

				@change="setValue({ key: 'goodsType', value: $event })"
			/>

			<EconomicalStatusesFormInput
				:selectedItem="order.economicalStatus"
				:disabled="orderIsLocked"
				enableFocusNextOnKeyboardSelect

				@change="adjustEconomicalStatus({ key: 'economicalStatus', value: $event })"
			/>

			<div class="invoice">
				<TLabeledValue
					class="invoice-label"
					:label="$t('invoiceNumber')"
					:value="invoiceNumberString"
					horizontal
				/>

				<TLabeledValue
					class="invoice-label"
					:label="$t('invoiceCurrency')"
					:value="invoicePriceAndCurrencyString"
					horizontal
				/>

				<TLabeledValue
					class="invoice-label"
					:label="$t('baseCurrency')"
					:value="basePriceAndCurrencyString"
					horizontal
				/>

				<TLabeledValue
					:label="$t('billingType')"
					:value="billingTypeString"
					horizontal
				/>
			</div>

			<ClerkInput
				ref="clerksFormInput"
				:value="order.clerk"
				:disabled="orderIsLocked"
				focusNextOnSelected
				@change="setValue({key: 'clerk', value: $event})"
			/>

			<TTextInput
				:label="$t('poReference')"
				:value="order.poReference"
				:disabled="orderIsLocked"

				@input="setValue({ key: 'poReference', value: $event })"
			/>

			<TTextInput
				:label="$t('sendersReference')"
				:value="order.sendersReference"
				:disabled="orderIsLocked"

				@input="setValue({ key: 'sendersReference', value: $event })"
			/>
		</div>

		<div class="customer-addresses-and-time">
			<CustomerAndAddresses
				ref="customerAndAddresses"
				:order="order"
				:incoterm="incoterm"
				:incotermsPlace="order.incotermsPlace"

				@changeCustomer="setCustomer({ customer: $event })"
				@updateCustomerByNumber="getAndSetCustomerByNumber( $event )"
				@changeConsignor="setOrderConsignor"
				@changeConsignee="setOrderConsignee"
				@changeDespatchParty="setOrderDespatchParty"
				@changeDeliveryParty="setOrderDeliveryParty"

				@setIncotermsCode="setValue({ key: 'incotermsCode', value: $event })"
				@setIncotermsPlace="setValue({ key: 'incotermsPlace', value: $event })"
			/>

			<Time
				ref="time"
				class="time"
				:order="order"
				:orderErrors="errors.order"

				:atdSignature="atdSignature"
				:ataSignature="ataSignature"

				@changeEtdDate="setDate({ key: 'etd', dateValue: $event, hasTime: 'dont-change' })"
				@changeEtdTime="setDate({ key: 'etd', timeValue: $event, hasTime: Boolean($event) })"

				@changeAtdDate="setDate({ key: 'atd', dateValue: $event, hasTime: 'dont-change' })"
				@changeAtdTime="setDate({ key: 'atd', timeValue: $event, hasTime: Boolean($event) })"

				@changeEtaDate="setDate({ key: 'eta', dateValue: $event, hasTime: 'dont-change' })"
				@changeEtaTime="setDate({ key: 'eta', timeValue: $event, hasTime: Boolean($event) })"

				@changeAtaDate="setDate({ key: 'ata', dateValue: $event, hasTime: 'dont-change' })"
				@changeAtaTime="setDate({ key: 'ata', timeValue: $event, hasTime: Boolean($event) })"
			/>
		</div>

		<DetailsMain
			ref="detailsMain"
			:currentTabId="currentDetailTabId"

			@setSelectedTab="$emit('setSelectedDetailsTab', $event)"
			@mounted="$emit('detailsMainMounted', $event)"
		/>
	</div>

</template>

<script>
import {
	mapState, mapActions, mapMutations, mapGetters
} from './store/newOrder.store.js';
import {
	mapState as mapStateIncoterms, mapActions as mapActionsIncoterms
} from '../incoterms/store/incoterms.store';

import {
	statuses, formatCurrency
} from '@/core';

import EconomicalStatusesFormInput from '@/modules/economicalStatuses/EconomicalStatusesFormInput.vue';
import ClerkInput from '@/modules/clerks/ClerkInput';
import GoodsTypesFormInput from '@/modules/goodsTypes/GoodsTypesFormInput';
import OrderTypesFormInput from '@/modules/orderTypes/OrderTypesFormInput';
import OrderStatusesFormInput from '@/modules/orderStatuses/OrderStatusesFormInput';
import CustomerAndAddresses from '@/modules/newOrder/common/CustomerAndAddresses';
import Time from '@/modules/newOrder/common/Time';
import TTextInput from '@/components/evergreen/inputs/TTextInput';
import DetailsMain from '@/modules/newOrder/details/DetailsMain';
import TLabeledValue from '@/components/evergreen/timpex/layers/TLabeledValue';

export default {
	name: 'MainOrderContent',
	components: {
		TLabeledValue,
		TTextInput,
		Time,
		CustomerAndAddresses,
		EconomicalStatusesFormInput,
		ClerkInput,
		GoodsTypesFormInput,
		OrderTypesFormInput,
		OrderStatusesFormInput,
		DetailsMain,
	},
	props: {
		isNewOrder: {
			type: Boolean,
			required: true
		},
		currentDetailTabId: {
			type: String,
			required: true
		},
		orderHasTrip: Boolean,
	},
	computed: {
		...mapState([
			'order',
			'loadedTemplate',
			'errors',
			'subOrders',
		]),
		...mapStateIncoterms(['incoterms']),
		...mapGetters(['orderIsLocked']),

		atdSignature() {
			let signature = null;

			let collectedEvent = this.order.events && this.order.events.find(
				event => event.type === 'collected'
			);

			if (collectedEvent && (collectedEvent.signatureName || collectedEvent.signatureUrl)) {

				signature = {
					name: collectedEvent.signatureName,
					url: collectedEvent.signatureUrl
				};
			}
			return signature;
		},

		ataSignature() {
			let signature = null;

			let deliveredEvent = this.order.events && this.order.events.find(
				event => event.type === 'delivered'
			);

			if (deliveredEvent && (deliveredEvent.signatureName || deliveredEvent.signatureUrl)) {

				signature = {
					name: deliveredEvent.signatureName,
					url: deliveredEvent.signatureUrl
				};
			}
			return signature;
		},

		invoiceNumberString() {
			if (this.isNewOrder)
				return '...';

			else if (this.order.invoiceNumber === undefined || this.order.invoiceNumber === null)
				return this.$t('notSet');

			else
				return this.order.invoiceNumber;
		},
		basePriceAndCurrencyString() {
			if (this.isNewOrder)
				return '...';

			else if (this.order.totalPrice === undefined || this.order.totalPrice === null)
				return this.$t('notSet');

			else
				return formatCurrency(this.order.totalPrice, this.order.currency);
		},
		invoicePriceAndCurrencyString() {
			if (this.isNewOrder)
				return '...';

			else if (this.order.invoiceCurrencyPrice === undefined || this.order.invoiceCurrencyPrice === null)
				return this.$t('notSet');

			else
				return formatCurrency(this.order.invoiceCurrencyPrice, this.order.invoiceCurrency);
		},
		billingTypeString() {
			if (this.isNewOrder)
				return '...';

			if (this.order.billingType === undefined)
				return this.$t('notSet');

			if (this.order.billingType === 'aborted')
				return this.$t('billingTypeAborted');

			else if (this.order.billingType === 'settlement')
				return this.$t('billingTypeSettlement');

			else if (this.order.billingType === 'invoice')
				return this.$t('billingTypeInvoice');

			else if (this.order.billingType === 'notCleared')
				return this.$t('billingTypeNotCleared');

			else
				return this.$t('billingTypeUnkown');

		},
		incoterm() { // Need this because order only saves incotermCode, not the full incoterm object
			if (
				this.incoterms
				&& this.incoterms.length
				&& this.order.incotermsCode
			)
				return this.incoterms.find( incoterm => incoterm.code === this.order.incotermsCode );

			else if (this.order.incotermsCode)
				return { incotermsCode: this.order.incotermsCode };

			else
				return null;
		},
	},

	async created() {
		await this.getIncoterms();
	},

	methods: {
		...mapActions([
			'saveNewOrder',
			'saveOrder',
			'cleanState',
			'setEditOrder',
			'openTmsR10',
			'setOrderEtd',
			'getAndSetCustomerByNumber'
		]),
		...mapMutations([
			'setValue',
			'setDate',
			'setCustomer',
			'setOrderParty',
			'setOrderConsignor',
			'setOrderConsignee',
			'setOrderDespatchParty',
			'setOrderDeliveryParty',
		]),
		...mapActionsIncoterms([ 'getIncoterms' ]),

		adjustEconomicalStatus(data) {
			this.setValue(data);

			if (data.value === statuses.economical.cancelled)
				this.setValue({ key: 'status', value: statuses.operational.cancelled });
		},
		getStatusColor(value) {
			return statuses.color(value);
		},

		getFirstInputElementByRef(ref) {
			return ref.$el.querySelector('input');
		},
		getFirstTabableElementByRef(ref) {
			return ref.$el.querySelector('input:not([tabindex="-1"]), textarea');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.new-order {
	height: 100%;
	display:flex;
	flex-direction: column;
}

.invoice {

	grid-area: 1 / 5 / 3 / 6;

	.invoice-label {
		margin-bottom: 12px;
	}
}

.customer-addresses-and-time {
	display: flex;
}

.time {
	margin-left: 16px;
	margin-top: 12px;
}

.general-status {
	display: grid;
	grid-template-columns: repeat(5, minmax(200px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
	margin-bottom: 20px;
}

.textInfo {

	.header {
		user-select: none;
		font-size: 11px;
		font-weight: 600;
		line-height: 1.45;
		letter-spacing: 0.3px;
		color: get-color($text, 'dark');
		text-transform: uppercase;
		margin-bottom: 3px;
		margin-left: 1px;
	}
	.content {
		display: grid;
		column-gap: 5px;
		row-gap: 5px;
		line-height: 40px;
	}
}

hr {
	grid-column: 1 / auto-fill;
	height: 1px;
	background: get-color($border, 'default');
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	border: 0;
}

</style>
